import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Directives from "@/pages/Directives";
import Approvals from "@/pages/Approvals";
import ApprovalDetail from "@/pages/ApprovalDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Schedule from "@/pages/Schedule";
import Agents from "@/pages/Agents";
import Files from "@/pages/Files";
import Audit from "@/pages/Audit";
import ExecutiveBrief from "@/pages/ExecutiveBrief";
import OwnerMind from "@/pages/OwnerMind";
import Orchestration from "@/pages/Orchestration";
import Org from "@/pages/Org";
import AgentOS from "@/pages/AgentOS";
import DesignPackets from "@/pages/DesignPackets";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-muted">
        <Loader2 className="w-6 h-6 animate-spin text-brand" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <AppProvider>
                  <AppShell />
                </AppProvider>
              </Protected>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/brief" element={<ExecutiveBrief />} />
            <Route path="/owner-mind" element={<OwnerMind />} />
            <Route path="/orchestration" element={<Orchestration />} />
            <Route path="/org" element={<Org />} />
            <Route path="/agent-os" element={<AgentOS />} />
            <Route path="/design-packets" element={<DesignPackets />} />
            <Route path="/directives" element={<Directives />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/approvals/:id" element={<ApprovalDetail />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/files" element={<Files />} />
            <Route path="/audit" element={<Audit />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
